import { useTypedSelector } from "App/Store";
import clsx from "clsx";
import { Message } from "pages/MatchChat";
import { useEffect, useRef } from "react";
import CheveronLeftBold from "shared/icons/CheveronLeftBold";
import avatar2 from "../../../assets/icons/avatar2.jpeg";

export default function TournamentMessageCard({
  isDropDown,
  openDropdownModal,
  closeDropdownModal,
  message,
  teamClass,
  isGroupChat,
  handleViewImage,
  openDeleteModal,
  teamNameByUserId,
}: {
  message: Message;
  teamClass: string;
  handleViewImage: (image: string) => void;
  isDropDown: {
    open: boolean;
    messageId: string;
  };
  isGroupChat: boolean;
  openDropdownModal: (messageId: string) => void;
  closeDropdownModal: () => void;
  openDeleteModal: (messageId: string) => void;
  teamNameByUserId?: Record<string, string>;
}) {
  const { user } = useTypedSelector((state) => state.userDetails);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const teamName = teamNameByUserId?.[message.senderId?.toString()] || "";

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        if (isDropDown?.open && isDropDown?.messageId === message.id) {
          closeDropdownModal();
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropDown, message.id, closeDropdownModal]);
  return (
    <div
      className={clsx(
        "card-conatiner",
        message?.sender === "me" ||
          user?.id?.toString() === message?.senderId.toString()
          ? "user-msg"
          : ""
      )}
    >
      <div className={"card-img-wrapper"}>
        <img
          src={message?.profileImage || avatar2}
          alt="profile img"
          className={"profile-img"}
          height={48}
          width={48}
        />
      </div>
      <div className={"card-msg-details"}>
        <div className={"card-details"} ref={dropdownRef}>
          <h6
            className={clsx("user-name", isGroupChat && teamClass)}
            style={isGroupChat ? { color: teamClass } : undefined}
          >
            {message.name}
            {isGroupChat && teamName ? <span> ({teamName}) </span> : ""}
          </h6>
          <div className={"dot"}></div>
          <div className={"msg-time"}>{message.time} </div>
          {message?.metadata?.captain === "captain" && (
            <>
              <div className={"dot"}></div>
              <div className={"captain-detail"}>
                <p>CAPTAIN</p>
              </div>
            </>
          )}
          {message?.role === "admin" && (
            <>
              <div className={"dot"}></div>
              <div className={"captain-detail"}>
                <p>MODERATOR</p>
              </div>
            </>
          )}
          {!message.isDeleted && (
          <div
            className="drop-down-btn"
            onClick={(e) => {
              e.stopPropagation();
              openDropdownModal(message.id);
            }}
          >
            <CheveronLeftBold
              rotate={
                isDropDown?.messageId === message.id && isDropDown.open
                  ? 90
                  : 270
              }
            />

            {isDropDown?.messageId === message.id && isDropDown.open && (
              <div className="drop-down-wrapper">
                {/* <div className="drop-down-item">Edit</div> */}
                <div
                  className="drop-down-item delete"
                  onClick={(e) => {
                    openDeleteModal(message.id);
                  }}
                >
                  Delete
                </div>
              </div>
            )}
          </div>
          )}
        </div>
        {message?.attachments?.length && message?.attachments?.length > 0 ? (
          <div className={"images-wrapper"}>
            {message?.attachments.map((attch, index) => {
              return (
                <div
                  key={index}
                  className={"chat-image"}
                  onClick={() => {
                    handleViewImage(attch);
                  }}
                >
                  <img
                    src={attch}
                    alt=""
                    className={"chat-img"}
                    height={200}
                    width={250}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}
        {message.isDeleted ? (
          <p className={"deleted-message"}>
            {" "}
            <span> {/* <CrossOutlined /> */}</span> This message was deleted
          </p>
        ) : (
          <p className={"card-msg"}>{message?.text}</p>
        )}
      </div>
    </div>
  );
}
